module.exports = __webpack_public_path__ + "static/media/campus_29.2ce08c92.png";